import {Component, createElement} from 'react';
import styles from './ApplicationMessages.scss';
import icons from 'styles/icons/icons.scss';
import {connect} from 'react-redux';
import {get, take, orderBy} from 'lodash';
import {removeApplicationMessage} from 'common/actions/applicationMessagesActions';
import DateTime from 'common/components/DateTime/DateTime';
const MAXIMUM_VISIBLE_MESSAGES = 5;
import { DEFAULT_DATETIME_INPUT_FORMAT } from 'common/util/dateTime';

export class ApplicationMessages extends Component {
    render() {
        const allMessages = this.props.messages;
        const messages = take(allMessages, MAXIMUM_VISIBLE_MESSAGES);

        const renderedMessages = messages.map((m, i) => {
            return <ApplicationMessageFactory {...m} key={i} removeApplicationMessage={this.props.removeApplicationMessage} />;
        });

        return (
            <div className={styles.applicationMessagesHost} data-cy="ApplicationMessages-renderedMessages">
                {renderedMessages}
            </div>
        );
    }
}

export class ApplicationMessageFactory extends Component {
    getMessageType() {
        switch (`${this.props.type}`.toLowerCase()) {
            case 'error':
                return ErrorMessage;
            case 'success':
                return SuccessMessage;
            case 'info':
                return InfoMessage;
            case 'warning':
                return WarningMessage;
            case 'download':
                return DownloadMessage;
            case 'login':
                return LoginMessage;
            default:
                return ApplicationMessage;
        }
    }

    render() {
        const type = this.getMessageType();
        return createElement(type, this.props);
    }
}

export class ApplicationMessage extends Component {
    componentDidMount() {
        const ttl = Number(get(this.props, 'messageData.ttl'));
        if (ttl > 0) {
            setTimeout(this.close.bind(this), ttl);
        }
    }

    className() {
        return styles.applicationMessage;
    }

    close() {
        this.props.removeApplicationMessage(this.props.id);
    }

    render() {
        return (
            <div className={styles.applicationMessageContainer} onClick={this.close.bind(this)} data-cy="ApplicationMessages">
                <div className={this.className()}>
                    <div className={styles.messageBodyContainer}>
                        {this.renderIcon()}
                        <span className={styles.messageBody}>{this.renderBody()}</span>
                    </div>
                    <div className={styles.messageHeader}>
                        <span className={styles.messageHeaderText} />
                        <span className={icons.materialIcons}>close</span>
                    </div>
                </div>
            </div>
        );
    }

    renderIcon() {
        return null;
    }

    renderBody() {
        return <span>{this.props.message}</span>;
    }
}

export class ErrorMessage extends ApplicationMessage {
    className() {
        return styles.errorMessage;
    }

    renderIcon() {
        return <span className={icons.materialIcons} data-cy="ApplicationMessages-report">report</span>;
    }
}

export class SuccessMessage extends ApplicationMessage {
    className() {
        return styles.successMessage;
    }

    renderIcon() {
        return <span className={icons.materialIcons} data-cy="ApplicationMessages-circle">check_circle</span>;
    }
}

export class InfoMessage extends ApplicationMessage {
    className() {
        return styles.infoMessage;
    }

    renderIcon() {
        return <span className={icons.materialIcons} data-cy="ApplicationMessages-info">info</span>;
    }
}

export class WarningMessage extends ApplicationMessage {
    className() {
        return styles.warningMessage;
    }

    renderIcon() {
        return <span className={icons.materialIcons} data-cy="ApplicationMessages-warning">warning</span>;
    }
}

export class DownloadMessage extends ApplicationMessage {
    className() {
        return styles.infoMessage;
    }

    renderIcon() {
        return <span className={icons.materialIcons} data-cy="ApplicationMessages-renderIcon">warning</span>;
    }

    renderBody() {
        return (
            <span data-cy="ApplicationMessages-renderBody">
                <span>Your download will begin shortly (or click <a rel="noopener" target="_blank" href={this.props.message}>here</a>).</span>
                <iframe className={styles.downloadFrame} src={this.props.message} ></iframe>
            </span>
        );
    }
}

export class LoginMessage extends InfoMessage{
    renderBody() {
        const { message } = this.props;
        return (
            <span data-cy="ApplicationMessages-LoginMessage">
                <span>
                    Welcome back! You previously logged in on
                </span>
                &nbsp;
                <DateTime value={message} inputFormat={DEFAULT_DATETIME_INPUT_FORMAT} time={true} format={'DD MMM YYYY hh:mm AZ'} data-cy="ApplicationMessages-DateTime"/>
                <span>
                    . Contact support if that is incorrect.
                </span>
            </span>
        );
    }
}

export default connect(function (state) {
    return {
        messages: orderBy(state.messages, ['timestamp'], ['desc'])
    };
}, {
    removeApplicationMessage
})(ApplicationMessages);
